import API from "../constants/api.constant";
import { responseErrorHandling } from "../helper/common.helper";
import axiosInstance from "./axiosInstance";

// Get all leads
export const getLeads = async (params: any) => {
  try {
    const response = await axiosInstance.get(API.GET_ALL_LEAD, { params });
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

// Search leads for customer conversion
export const searchLeads = async (query: string, businessId: string) => {
  try {
    const response = await axiosInstance.get(API.GET_ALL_LEAD, {
      params: {
        search: query,
        businessId: businessId,
        status: "Pending"
      },
    });
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

// Create lead
export const createLead = async (data: any) => {
  try {
    const response = await axiosInstance.post(API.CREATE_LEAD, data);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

// Update lead
export const updateLead = async (id: string, data: any) => {
  try {
    const response = await axiosInstance.patch(
      `${API.UPDATE_LEAD}/${id}`,
      data
    );
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

// Delete lead
export const deleteLead = async (id: string) => {
  try {
    const response = await axiosInstance.delete(`${API.DELETE_LEAD}/${id}`);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

// Invite lead
export const inviteLead = async (data: any) => {
  try {
    const response = await axiosInstance.post(API.INVITE_LEAD, data);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

export const inviteLeadUser = async (data: any) => {
  try {
    const response = await axiosInstance.post(`${API.INVITE_USER_LEAD}${data.id}`);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

// create lead
export const createLeadNote = async (id: string, leadNote: any) => {
  try {
    const response = await axiosInstance.post(API.LEAD_NOTE_CREATE + id, leadNote);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
}

// delete lead
export const deleteLeadNote = async (id: string) => {
  try {
    const response = await axiosInstance.delete(API.DELETE_LEAD_NOTE + id);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
}

// update lead note
export const updateLeadNote = async (id: string, leadNote: any) => {
  try {
    const response = await axiosInstance.patch(API.UPDATE_LEAS_NOTE + id, leadNote);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
}

